module.exports = __webpack_public_path__ + "img/medication-empty@2x.78511607.png";